import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: 'Login' */'../views/Login')
    },

    {
        path: '/register',
        name: 'Register',
        component: () => import(/* webpackChunkName: 'Register' */'../views/Register')
    },
    {
        path: '/forgetPwd',
        name: 'ForgetPwd',
        component: () => import(/* webpackChunkName: 'ForgetPwd' */'../views/ForgetPwd')
    },
    {
        path: '/resStoreDetail2',
        name: 'ResStoreDetail2',
        component: () => import('../views/user/resource/ResStoreDetail')
    },
    {
        name: 'ResDelivery',
        path: '/resDelivery',
        component: () => import(/* webpackChunkName: 'User'*/ '../views/ResDelivery'),
    },
    {
        name: 'newsContent',
        path: '/newsContent',
        component: () => import(/* webpackChunkName: 'User'*/ '../views/NewsContent'),
    },
    {
        path: '/science/applyResultInfo',
        name: 'applyResultInfo',
        component: () => import(/* webpackChunkName: 'About'*/'../views/science/ApplyResultInfo')
    },
    {
        path: '/',
        name: 'Main',
        component: () => import(/* webpackChunkName: 'Main' */'../views/Main'),
        redirect: '/index',
        children: [
            {
                path: '/',
                name: 'Index',
                component: () => import(/* webpackChunkName: 'Index' */'../views/Index')
            },
            {
                path: '/contest',
                name: 'Contest',
                component: () => import(/* webpackChunkName: 'Main' */'../views/Contest')
            },
            {
                path: '/platform',
                name: 'Platform',
                component: () => import(/* webpackChunkName: 'Platform' */'../views/Platform'),
                meta: {
                    keepAlive: true
                }
            },
            {
                path: '/organ',
                name: 'Organ',
                component: () => import(/* webpackChunkName: 'Organ' */'../views/Organ')
            },
            {
                path: '/topic',
                name: 'Topic',
                component: () => import(/* webpackChunkName: 'Topic' */'../views/Topic')
            },
            {
                path: '/topicDetail',
                name: 'TopicDetail',
                component: () => import(/* webpackChunkName: 'TopicDetail' */'../views/TopicDetail')
            },
            {
                path: '/tech',
                name: "Tech",
                component: () => import(/* webpackChunkName: 'Tech' */'../views/Tech')
            },
            {
                path: '/institution',
                name: 'Institution',
                component: () => import(/* webpackChunkName: 'Institution' */'../views/Institution')
            },
            {
                path: '/newsDetail',
                name: 'NewsDetail',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/NewsDetail')
            },
            {
                path: '/newsDetailNoLogin',
                name: 'NewsDetailNoLogin',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/NewsDetailNoLogin')
            },
            {
                path: '/yuanqujianjie',
                name: 'Yuanqujianjie',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Yuanqujianjie.vue')
            },
            {
                path: '/xingdongfangan',
                name: 'Xingdongfangan',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Xingdongfangan.vue')
            },
            {
                path: '/gongshanglianzhichi',
                name: 'Gongshanglianzhichi',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Gongshanglianzhichi.vue')
            },
            {
                path: '/guangzhouzhichi',
                name: 'Guangzhouzhichi',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Guangzhouzhichi.vue')
            },
            {
                path: '/platformcyzq',
                name: 'Platformcyzq',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Platformcyzq.vue')
            },
            {
                path: '/zhengcezhichi',
                name: 'Zhengcezhichi',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Zhengcezhichi.vue')
            },
            {
                path: '/tizhikuorong',
                name: 'Tizhikuorong',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Tizhikuorong.vue')
            },
            {
                path: '/shuzijijian',
                name: 'Shuzijijian',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/zone/minban/Shuzijijian.vue')
            },
            {
                path: '/techRes',
                name: 'TechRes',
                component: () => import(/* webpackChunkName: 'TechRes' */'../views/TechRes')
            },
            {
                path: '/instrument',
                name: 'Instrument',
                component: () => import(/* webpackChunkName: 'Instrument' */'../views/Instrument')
            },
            {
                path: '/industry',
                name: 'Industry',
                component: () => import(/* webpackChunkName: 'Industry' */'../views/zone/minban/Industry.vue')
            },
            {
                path: '/specialIndustry',
                name: 'SpecialIndustry',
                component: () => import(/* webpackChunkName: 'Industry' */'../views/SpecialIndustry')
            },
            {
                path: '/achievement',
                name: 'Achievement',
                component: () => import(/* webpackChunkName: 'Industry' */'../views/Achievement')
            },
            {
                path: '/xuqiuzixun',
                name: 'Xuqiuzixun',
                component: () => import(/* webpackChunkName: 'Industry' */'../views/Xuqiuzixun')
            },
            {
                path: '/industryDetail',
                name: 'IndustryDetail',
                component: () => import(/* webpackChunkName: 'IndustryDetail' */'../views/zone/minban/IndustryDetail.vue')
            },
            {
                path: '/industryPlatformDetail',
                name: 'IndustryPlatformDetail',
                component: () => import(/* webpackChunkName: 'IndustryPlatformDetail' */'../views/zone/minban/IndustryPlatformDetail.vue')
            },
            {
                path: '/industryPlatformList',
                name: 'IndustryPlatformList',
                component: () => import(/* webpackChunkName: 'IndustryPlatformList' */'../views/zone/minban/IndustryPlatformList.vue')
            },
            {
                path: '/industryDetailTemp',
                name: 'IndustryDetailTemp',
                component: () => import(/* webpackChunkName: 'IndustryDetailTemp' */ '../views/zone/minban/IndustryDetailTemp.vue')
            },
            {
                path: '/DataResource',
                name: 'DataResource',
                component: () => import(/* webpackChunkName: 'IndustryDetailTemp' */ '../views/DataResource')
            },
            {
                path: '/DataResourceType',
                name: 'DataResourceType',
                component: () => import(/* webpackChunkName: 'IndustryDetailTemp' */ '../views/DataResourceType')
            },
            {
                path: '/training',
                name: 'Training',
                component: () => import(/* webpackChunkName: 'Training' */ '../views/Training')
            },
            {
                path: '/newsListPage',
                name: 'NewsListPage',
                component: () => import(/* webpackChunkName: 'NewsListPage'*/ '../views/NewsListPage')
            },
            {
                path: '/downloadList',
                name: 'DownloadList',
                component: () => import(/* webpackChunkName: 'DownloadList' */'../views/DownloadList')
            },
            {
                path: '/building',
                name: 'Building',
                component: () => import(/* webpackChunkName: 'Building' */'../views/Building')
            },
            {
                path: '/about',
                name: 'About',
                component: () => import(/* webpackChunkName: 'About'*/ '../views/about/Index'),
                redirect: '/about/history',
                children: [
                    {
                        path: 'history',
                        name: 'History',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/about/History')
                    },
                    {
                        path: 'dependent',
                        name: 'Dependent',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/about/Dependent')
                    },
                    {
                        path: 'entry',
                        name: 'Entry',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/about/Entry')
                    },
                    {
                        path: 'manage',
                        name: 'Manage',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/about/Manage')
                    },
                    {
                        path: 'data',
                        name: 'Data',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/about/Data')
                    },
                    {
                        path: 'contact',
                        name: 'Contact',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/about/Contact')
                    }
                ]
            },
            {
                name: 'User',
                path: '/user',
                component: () => import(/* webpackChunkName: 'User'*/ '../views/user/Index'),
                redirect: '/user/baseInfo',
                children: [
                    {
                        name: 'BaseInfo',
                        path: 'baseInfo',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/BaseInfo'),
                    },
                    {
                        name: 'PwdSetting',
                        path: 'pwdSetting',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/PwdSetting'),
                    },
                    {
                        name: 'MessageMgr',
                        path: 'messageMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/MessageMgr'),
                    },
                    {
                        name: 'MessageDetail',
                        path: 'messageDetail',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MessageDetail'),
                    },
                    {
                        name: 'Collect',
                        path: 'collect',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/Collect'),
                    },
                    {
                        name: 'DownloadMgr',
                        path: 'downloadMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DownloadMgr'),
                    },
                    {
                        name: 'UserBuilding',
                        path: 'userBuilding',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/UserBuilding'),
                    },
                    {
                        name: 'Upgrading',
                        path: 'upgrading',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/Upgrading'),
                    },
                    {
                        name: 'PlatformMgr',
                        path: 'platformMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformMgr'),
                    },
                    {
                        name: 'BaseMaterials',
                        path: 'baseMaterials',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/BaseMaterials'),
                    },
                    {
                        name: 'ResStore',
                        path: 'resStore',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResStore'),
                    },
                    {
                        name: 'ResStoreDetail',
                        path: 'resStoreDetail',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResStoreDetail'),
                    },
                    {
                        name: 'ResInsServiceLog',
                        path: 'resInsServiceLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResInsServiceLog'),
                    },
                    {
                        name: 'ResDataProve',
                        path: 'resDataProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProve'),
                    },
                    {
                        name: 'ResDataProveNotice',
                        path: 'resDataProveNotice',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveNotice'),
                    },
                    {
                        name: 'ResDataProveSelection',
                        path: 'resDataProveSelection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveSelection'),
                    },
                    {
                        name: 'ResDataProveForm',
                        path: 'resDataProveForm',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveForm'),
                    },
                    {
                        name: 'ResRecordProve',
                        path: 'resRecordProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProve'),
                    },
                    {
                        name: 'ResRecordProveNotice',
                        path: 'resRecordProveNotice',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProveNotice'),
                    },
                    {
                        name: 'ResRecordProveSelection',
                        path: 'resRecordProveSelection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProveSelection'),
                    },
                    {
                        name: 'PlatformCheck',
                        path: 'platformCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformCheck'),
                    },
                    {
                        name: 'YiqiLogOffStateExamine',
                        path: 'yiqiLogOffStateExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/YiqiLogOffStateExamine'),
                    },
                    {
                        name: 'LaboratoryBasicInfoExamine',
                        path: 'laboratoryBasicInfoExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LaboratoryBasicInfoExamine'),
                    },
                    {
                        name: 'AnnualReportExamine',
                        path: 'annualReportExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/AnnualReportExamine'),
                    },
                    {
                        name: 'MyApplyLog',
                        path: 'myApplyLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MyApplyLog'),
                    },
                    {
                        name: 'CompetitionList',
                        path: 'competitionList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/competition/CompetitionList'),
                    },
                    {
                        name: 'EstInstruList',
                        path: 'estInstruList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/estimate/EstInstruList'),
                    },
                    {
                        name: 'UnitApplyLog',
                        path: 'unitApplyLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/UnitApplyLog'),
                    },
                    {
                        name: 'ApplyConfirm',
                        path: 'applyConfirm',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ApplyConfirm'),
                    },
                    {
                        name: 'Objection',
                        path: 'objection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/Objection'),
                    },
                    {
                        name: 'MyObjection',
                        path: 'myObjection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MyObjection'),
                    },
                    {
                        name: 'YearReportCheck',
                        path: 'yearReportCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/YearReportCheck'),
                    },
                    {
                        name: 'ResCheck',
                        path: 'resCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResCheck'),
                    },
                    {
                        name: 'DataCheck',
                        path: 'dataCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataCheck'),
                    },
                    {
                        name: 'PlatformManage',
                        path: 'platformManage',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformManage'),
                    },
                    {
                        name: 'LaboratoryBasicInfo',
                        path: 'laboratoryBasicInfo',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LaboratoryBasicInfo'),
                    },
                    {
                        name: 'PlatformChange',
                        path: 'platformChange',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformChange'),
                    },
                    {
                        name: 'PlatformFillIn',
                        path: 'platformFillIn',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformFillIn'),
                    },
                    {
                        name: 'InstrumentReservation',
                        path: 'instrumentReservation',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentReservation'),
                    },
                    {
                        name: 'InstrumentUseStatistics',
                        path: 'instrumentUseStatistics',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentUseStatistics'),
                    },
                    {
                        name: 'InstrumentReservationManage',
                        path: 'instrumentReservationManage',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentReservationManage'),
                    },
                    {
                        name: 'InstrumentUseApplication',
                        path: 'instrumentUseApplication',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentUseApplication'),
                    },
                    {
                        name: 'PlatformPages',
                        path: 'platformPages',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformPages'),
                    },
                    {
                        name: 'PlatformPageEdit',
                        path: 'platformPageEdit',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformPageEdit'),
                    },
                    {
                        name: 'PlatformYearReport',
                        path: 'platformYearReport',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformYearReport'),
                    },
                    {
                        name: 'PlatformDataProve',
                        path: 'platformDataProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformDataProve'),
                    },
                    {
                        name: 'DataStore',
                        path: 'dataStore',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/DataStore'),
                    },
                    {
                        name: 'DataCatagoryMgr',
                        path: 'dataCatagoryMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataCatagoryMgr'),
                    },
                    {
                        name: 'DataRes',
                        path: 'dataRes',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataRes'),
                    },
                    {
                        name: 'OpenTopic',
                        path: 'openTopic',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/OpenTopic'),
                    },
                    {
                        name: 'ApiKeyApply',
                        path: 'apiKeyApply',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ApiKeyApply'),
                    },
                    {
                        name: 'DataResProve',
                        path: 'dataResProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataResProve'),
                    },
                    {
                        name: 'LibAwards',
                        path: 'libAwards',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibAwards'),
                    },
                    {
                        name: 'LibExpert',
                        path: 'libExpert',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibExpert'),
                    },
                    {
                        name: 'LibFile',
                        path: 'libFile',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibFile'),
                    },
                    {
                        name: 'LibMedicine',
                        path: 'libMedicine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibMedicine'),
                    },
                    {
                        name: 'LibCommittee',
                        path: 'libCommittee',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibCommittee'),
                    },
                    {
                        name: 'LibMeeting',
                        path: 'libMeeting',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibMeeting'),
                    },
                    {
                        name: 'LibPaper',
                        path: 'libPaper',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPaper'),
                    },
                    {
                        name: 'LibPatent',
                        path: 'libPatent',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPatent'),
                    },
                    {
                        name: 'LibPerson',
                        path: 'libPerson',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPerson'),
                    },
                    {
                        name: 'LibProject',
                        path: 'libProject',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibProject'),
                    },
                    {
                        name: 'LibProjectProvince',
                        path: 'libProjectProvince',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibProjectProvince'),
                    },
                    {
                        name: 'LibEnterprise',
                        path: 'libEnterprise',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibEnterprise'),
                    },
                    {
                        name: 'LibPrincipalResults',
                        path: 'libPrincipalResults',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPrincipalResults'),
                    },
                    {
                        name: 'LibResearch',
                        path: 'libResearch',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibResearch'),
                    },
                    {
                        name: 'LibSoftness',
                        path: 'libSoftness',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibSoftness'),
                    },
                    {
                        name: 'LibStandard',
                        path: 'libStandard',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibStandard'),
                    },
                    {
                        name: 'LibWorks',
                        path: 'libWorks',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibWorks'),
                    },
                    {
                        name: 'ResReviewDuplication',
                        path: 'resReviewDuplication',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResReviewDuplication'),
                    },
                    {
                        name: 'scienceDataApplyList',
                        path: 'scienceDataApplyList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/science/ScienceDataApplyList'),
                    }

                ]
            },
            {
                name: 'Open',
                path: '/open',
                component: () => import(/* webpackChunkName: 'Open'*/ '../views/open/Open')
            },
            {
                name: 'DataShare',
                path: '/dataShare',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/DataShare')
            },
            {
                name: 'DataDownload',
                path: '/dataDownload',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/DataDownload')
            },
            {
                name: 'PlatformStatus',
                path: '/platformStatus',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/PlatformStatus')
            },
            {
                name: 'ReportDetail',
                path: '/reportDetail',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/ReportDetail')
            },
            {
                name: 'Report',
                path: '/report',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/Report')
            },
            {
                name: 'Statistics',
                path: '/statistics',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/Statistics')
            },
            {
                name: 'Introduce',
                path: '/introduce',
                component: () => import(/* webpackChunkName: 'DataShare'*/ '../views/open/Introduce')
            },
            {
                path: '/science',
                name: 'science',
                component: () => import(/* webpackChunkName: 'About'*/ '../views/science/Index'),
                redirect: '/science/home',
                children: [
                    {
                        path: 'home',
                        name: 'home',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/science/Home')
                    },
                    {
                        path: 'dataExchange',
                        name: 'dataExchange',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/science/DataExchange')
                    },
                    {
                        path: 'dataExchangeCertQuery',
                        name: 'dataExchangeCertQuery',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/science/DataExchangeCertQuery')
                    },
                    {
                        path: 'dataExchangeFile',
                        name: 'dataExchangeFile',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/science/DataExchangeFile')
                    },
                    {
                        path: 'dataCatalog',
                        name: 'dataCatalog',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/science/DataCatalog')
                    },
                    {
                        path: 'userApply',
                        name: 'userApply',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/science/UserApply')
                    }
                ]
            },
            {
                path: '/baiqianwan',
                name: 'baiqianwan',
                component: () => import(/* webpackChunkName: 'About'*/ '../views/zone/baiqianwan/Index'),
                redirect: '/baiqianwan/home',
                children: [
                    {
                        path: 'home',
                        name: 'baiqianwan_home',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/zone/baiqianwan/Home')
                    },
                    {
                        path: 'enterpriseList',
                        name: 'baiqianwan_enterpriseList',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/zone/baiqianwan/EnterpriseList')
                    },
                    {
                        path: 'enterpriseInfo',
                        name: 'baiqianwan_enterpriseInfo',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/zone/baiqianwan/EnterpriseInfo')
                    },
                    {
                        path: 'unitList',
                        name: 'baiqianwan_unitList',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/zone/baiqianwan/UnitList')
                    },
                    {
                        path: 'unitInfo',
                        name: 'baiqianwan_unitInfo',
                        component: () => import(/* webpackChunkName: 'About'*/'../views/zone/baiqianwan/UnitInfo')
                    },
                ]
            }

        ]
    },
    {
        path: '/zhuhai',
        name: 'ZhuhaiMain',
        component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhuhai/Main'),
        redirect: '/zhuhai/index',
        children: [
            {
                path: 'index',
                name: 'zhuhai',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhuhai/Index'),
                meta: {
                    title: '珠海分站'
                }
            },
            {
                path: 'resRetrieve',
                name: 'ResRetrieve',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhuhai/ResRetrieve'),
                meta: {
                    title: '资源检索'
                }
            },
            {
                path: 'zhuhaiPlatform',
                name: 'ZhuhaiPlatform',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhuhai/ZhuhaiPlatform.vue'),
                meta: {
                    title: '实验室与平台基地'
                }
            },
            {
                path: 'zhuhaiAbout',
                name: 'ZhuhaiAbout',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhuhai/ZhuhaiAbout.vue'),
                meta: {
                    title: '关于我们'
                }
            },
            {
                path: 'zhuhaiPlatformInfo',
                name: 'ZhuhaiPlatformInfo',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhuhai/ZhuhaiPlatformInfo.vue'),
                meta: {
                    title: '机构详情'
                }
            },
            {
                path: 'zhuhaiInstrumentInfo',
                name: 'ZhuhaiInstrumentInfo',
                component: () => import(/* webpackChunkName: 'Instrument' */'../views/Instrument')
            },
            {
                path: 'zhuhaiIndustryDetail',
                name: 'ZhuhaiIndustryDetail',
                component: () => import(/* webpackChunkName: 'Instrument' */'../views/zone/minban/IndustryDetail.vue')
            },
            {
                path: 'zhuhaiNewsDetail',
                name: 'ZhuhaiNewsDetail',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/NewsDetail')
            },
            {
                path: 'zhuhaiRegister',
                name: 'ZhuhaiRegister',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/Register'),
                meta: {
                    title: '注册'
                }
            },
            {
                path: 'zhuhaiInstitution',
                name: 'ZhuhaiInstitution',
                component: () => import(/* webpackChunkName: 'Institution' */'../views/zhuhai/ZhuhaiInstitution.vue')
            },
            {
                path: 'zhuhaiFillingGuide',
                name: 'ZhuhaiFillingGuide',
                component: () => import(/* webpackChunkName: 'Institution' */'../views/zhuhai/ZhuhaiFillingGuide.vue')
            },
            {
                path: 'zhuhaiLogin',
                name: 'ZhuhaiLogin',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/Login'),
                meta: {
                    title: '登录'
                }
            },
            {
                name: 'ZhuhaiUser',
                path: 'zhuhaiUser',
                component: () => import(/* webpackChunkName: 'User'*/ '../views/user/Index'),
                redirect: '/zhuhai/zhuhaiuser/baseInfo',
                children: [
                    {
                        name: 'ZhuhaiBaseInfo',
                        path: 'baseInfo',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/BaseInfo'),
                    },
                    {
                        name: 'ZhuhaiPwdSetting',
                        path: 'pwdSetting',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/PwdSetting'),
                    },
                    {
                        name: 'ZhuhaiMessageMgr',
                        path: 'messageMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/MessageMgr'),
                    },
                    {
                        name: 'ZhuhaiMessageDetail',
                        path: 'messageDetail',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MessageDetail'),
                    },
                    {
                        name: 'ZhuhaiCollect',
                        path: 'collect',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/Collect'),
                    },
                    {
                        name: 'ZhuhaiDownloadMgr',
                        path: 'downloadMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DownloadMgr'),
                    },
                    {
                        name: 'ZhuhaiUserBuilding',
                        path: 'userBuilding',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/UserBuilding'),
                    },
                    {
                        name: 'ZhuhaiUpgrading',
                        path: 'upgrading',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/Upgrading'),
                    },
                    {
                        name: 'ZhuhaiPlatformMgr',
                        path: 'platformMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformMgr'),
                    },
                    {
                        name: 'ZhuhaiBaseMaterials',
                        path: 'baseMaterials',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/BaseMaterials'),
                    },
                    {
                        name: 'ZhuhaiResStore',
                        path: 'resStore',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResStore'),
                    },
                    {
                        name: 'ZhuhaiResStoreDetail',
                        path: 'resStoreDetail',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResStoreDetail'),
                    },
                    {
                        name: 'ZhuhaiResInsServiceLog',
                        path: 'resInsServiceLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResInsServiceLog'),
                    },
                    {
                        name: 'ZhuhaiResDataProve',
                        path: 'resDataProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProve'),
                    },
                    {
                        name: 'ZhuhaiResDataProveNotice',
                        path: 'resDataProveNotice',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveNotice'),
                    },
                    {
                        name: 'ZhuhaiResDataProveSelection',
                        path: 'resDataProveSelection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveSelection'),
                    },
                    {
                        name: 'ZhuhaiResDataProveForm',
                        path: 'resDataProveForm',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveForm'),
                    },
                    {
                        name: 'ZhuhaiResRecordProve',
                        path: 'resRecordProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProve'),
                    },
                    {
                        name: 'ZhuhaiResRecordProveNotice',
                        path: 'resRecordProveNotice',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProveNotice'),
                    },
                    {
                        name: 'ZhuhaiResRecordProveSelection',
                        path: 'resRecordProveSelection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProveSelection'),
                    },
                    {
                        name: 'ZhuhaiPlatformCheck',
                        path: 'platformCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformCheck'),
                    },
                    {
                        name: 'ZhuhaiYiqiLogOffStateExamine',
                        path: 'yiqiLogOffStateExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/YiqiLogOffStateExamine'),
                    },
                    {
                        name: 'ZhuhaiLaboratoryBasicInfoExamine',
                        path: 'laboratoryBasicInfoExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LaboratoryBasicInfoExamine'),
                    },
                    {
                        name: 'ZhuhaiAnnualReportExamine',
                        path: 'annualReportExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/AnnualReportExamine'),
                    },
                    {
                        name: 'ZhuhaiMyApplyLog',
                        path: 'myApplyLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MyApplyLog'),
                    },
                    {
                        name: 'ZhuhaiCompetitionList',
                        path: 'competitionList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/competition/CompetitionList'),
                    },
                    {
                        name: 'ZhuhaiEstInstruList',
                        path: 'estInstruList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/estimate/EstInstruList'),
                    },
                    {
                        name: 'ZhuhaiUnitApplyLog',
                        path: 'unitApplyLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/UnitApplyLog'),
                    },
                    {
                        name: 'ZhuhaiApplyConfirm',
                        path: 'applyConfirm',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ApplyConfirm'),
                    },
                    {
                        name: 'ZhuhaiObjection',
                        path: 'objection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/Objection'),
                    },
                    {
                        name: 'ZhuhaiMyObjection',
                        path: 'myObjection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MyObjection'),
                    },
                    {
                        name: 'ZhuhaiYearReportCheck',
                        path: 'yearReportCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/YearReportCheck'),
                    },
                    {
                        name: 'ZhuhaiResCheck',
                        path: 'resCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResCheck'),
                    },
                    {
                        name: 'ZhuhaiDataCheck',
                        path: 'dataCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataCheck'),
                    },
                    {
                        name: 'ZhuhaiPlatformManage',
                        path: 'platformManage',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformManage'),
                    },
                    {
                        name: 'ZhuhaiLaboratoryBasicInfo',
                        path: 'laboratoryBasicInfo',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LaboratoryBasicInfo'),
                    },
                    {
                        name: 'ZhuhaiPlatformChange',
                        path: 'platformChange',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformChange'),
                    },
                    {
                        name: 'ZhuhaiPlatformFillIn',
                        path: 'platformFillIn',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformFillIn'),
                    },
                    {
                        name: 'ZhuhaiInstrumentReservation',
                        path: 'instrumentReservation',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentReservation'),
                    },
                    {
                        name: 'ZhuhaiInstrumentUseStatistics',
                        path: 'instrumentUseStatistics',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentUseStatistics'),
                    },
                    {
                        name: 'ZhuhaiInstrumentReservationManage',
                        path: 'instrumentReservationManage',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentReservationManage'),
                    },
                    {
                        name: 'ZhuhaiInstrumentUseApplication',
                        path: 'instrumentUseApplication',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentUseApplication'),
                    },
                    {
                        name: 'ZhuhaiPlatformPages',
                        path: 'platformPages',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformPages'),
                    },
                    {
                        name: 'ZhuhaiPlatformPageEdit',
                        path: 'platformPageEdit',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformPageEdit'),
                    },
                    {
                        name: 'ZhuhaiPlatformYearReport',
                        path: 'platformYearReport',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformYearReport'),
                    },
                    {
                        name: 'ZhuhaiPlatformDataProve',
                        path: 'platformDataProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformDataProve'),
                    },
                    {
                        name: 'ZhuhaiDataStore',
                        path: 'dataStore',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/DataStore'),
                    },
                    {
                        name: 'ZhuhaiDataCatagoryMgr',
                        path: 'dataCatagoryMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataCatagoryMgr'),
                    },
                    {
                        name: 'ZhuhaiDataRes',
                        path: 'dataRes',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataRes'),
                    },
                    {
                        name: 'ZhuhaiOpenTopic',
                        path: 'openTopic',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/OpenTopic'),
                    },
                    {
                        name: 'ZhuhaiApiKeyApply',
                        path: 'apiKeyApply',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ApiKeyApply'),
                    },
                    {
                        name: 'ZhuhaiDataResProve',
                        path: 'dataResProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataResProve'),
                    },
                    {
                        name: 'ZhuhaiLibAwards',
                        path: 'libAwards',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibAwards'),
                    },
                    {
                        name: 'ZhuhaiLibExpert',
                        path: 'libExpert',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibExpert'),
                    },
                    {
                        name: 'ZhuhaiLibFile',
                        path: 'libFile',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibFile'),
                    },
                    {
                        name: 'ZhuhaiLibMedicine',
                        path: 'libMedicine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibMedicine'),
                    },
                    {
                        name: 'ZhuhaiLibCommittee',
                        path: 'libCommittee',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibCommittee'),
                    },
                    {
                        name: 'ZhuhaiLibMeeting',
                        path: 'libMeeting',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibMeeting'),
                    },
                    {
                        name: 'ZhuhaiLibPaper',
                        path: 'libPaper',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPaper'),
                    },
                    {
                        name: 'ZhuhaiLibPatent',
                        path: 'libPatent',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPatent'),
                    },
                    {
                        name: 'ZhuhaiLibPerson',
                        path: 'libPerson',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPerson'),
                    },
                    {
                        name: 'ZhuhaiLibProject',
                        path: 'libProject',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibProject'),
                    },
                    {
                        name: 'ZhuhaiLibProjectProvince',
                        path: 'libProjectProvince',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibProjectProvince'),
                    },
                    {
                        name: 'ZhuhaiLibEnterprise',
                        path: 'libEnterprise',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibEnterprise'),
                    },
                    {
                        name: 'ZhuhaiLibPrincipalResults',
                        path: 'libPrincipalResults',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPrincipalResults'),
                    },
                    {
                        name: 'ZhuhaiLibResearch',
                        path: 'libResearch',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibResearch'),
                    },
                    {
                        name: 'ZhuhaiLibSoftness',
                        path: 'libSoftness',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibSoftness'),
                    },
                    {
                        name: 'ZhuhaiLibStandard',
                        path: 'libStandard',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibStandard'),
                    },
                    {
                        name: 'ZhuhaiLibWorks',
                        path: 'libWorks',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibWorks'),
                    },
                    {
                        name: 'ZhuhaiResReviewDuplication',
                        path: 'resReviewDuplication',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResReviewDuplication'),
                    },
                    {
                        name: 'ZhuhaiScienceDataApplyList',
                        path: 'scienceDataApplyList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/science/ScienceDataApplyList'),
                    }
                ]
            },
        ]
    },
    {
        path: '/zhaoqing',
        name: 'ZhaoqingMain',
        component: () => import(/* webpackChunkName: 'Zhaoqing'*/ '../views/zhaoqing/Main'),
        redirect: '/zhaoqing/index',
        children: [
            {
                path: 'index',
                name: 'zhaoqing',
                component: () => import(/* webpackChunkName: 'Zhaoqing'*/ '../views/zhaoqing/Index'),
                meta: {
                    title: '肇庆分站'
                }
            },
            {
                path: 'zhaoqingResRetrieve',
                name: 'ZhaoqingResRetrieve',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhaoqing/ZhaoqingResRetrieve'),
                meta: {
                    title: '资源检索'
                }
            },
            {
                path: 'zhaoqingPlatform',
                name: 'ZhaoqingPlatform',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhaoqing/ZhaoqingPlatform.vue'),
                meta: {
                    title: '实验室与平台基地'
                }
            },
            {
                path: 'zhaoqingAbout',
                name: 'ZhaoqingAbout',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhaoqing/ZhaoqingAbout.vue'),
                meta: {
                    title: '关于我们'
                }
            },
            {
                path: 'zhaoqingPlatformInfo',
                name: 'ZhaoqingPlatformInfo',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/zhaoqing/ZhaoqingPlatformInfo.vue'),
                meta: {
                    title: '机构详情'
                }
            },
            {
                path: 'zhaoqingInstrumentInfo',
                name: 'ZhaoqingInstrumentInfo',
                component: () => import(/* webpackChunkName: 'Instrument' */'../views/Instrument')
            },
            {
                path: 'zhaoqingIndustryDetail',
                name: 'ZhaoqingIndustryDetail',
                component: () => import(/* webpackChunkName: 'Instrument' */'../views/zone/minban/IndustryDetail.vue')
            },
            {
                path: 'zhaoqingNewsDetail',
                name: 'ZhaoqingNewsDetail',
                component: () => import(/* webpackChunkName: 'NewsDetail' */'../views/NewsDetail')
            },
            {
                path: 'zhaoqingRegister',
                name: 'ZhaoqingRegister',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/Register'),
                meta: {
                    title: '注册'
                }
            },
            {
                path: 'zhaoqingInstitution',
                name: 'ZhaoqingInstitution',
                component: () => import(/* webpackChunkName: 'Institution' */'../views/zhaoqing/ZhaoqingInstitution.vue')
            },
            {
                path: 'zhaoqingFillingGuide',
                name: 'ZhaoqingFillingGuide',
                component: () => import(/* webpackChunkName: 'Institution' */'../views/zhaoqing/ZhaoqingFillingGuide.vue')
            },
            {
                path: 'zhaoqingLogin',
                name: 'ZhaoqingLogin',
                component: () => import(/* webpackChunkName: 'Zhuhai'*/ '../views/Login'),
                meta: {
                    title: '登录'
                }
            },
            {
                name: 'ZhaoqingUser',
                path: 'zhaoqingUser',
                component: () => import(/* webpackChunkName: 'User'*/ '../views/user/Index'),
                redirect: '/zhaoqing/zhaoqinguser/baseInfo',
                children: [
                    {
                        name: 'ZhaoqingBaseInfo',
                        path: 'baseInfo',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/BaseInfo'),
                    },
                    {
                        name: 'ZhaoqingPwdSetting',
                        path: 'pwdSetting',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/PwdSetting'),
                    },
                    {
                        name: 'ZhaoqingMessageMgr',
                        path: 'messageMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/MessageMgr'),
                    },
                    {
                        name: 'ZhaoqingMessageDetail',
                        path: 'messageDetail',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MessageDetail'),
                    },
                    {
                        name: 'ZhaoqingCollect',
                        path: 'collect',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/Collect'),
                    },
                    {
                        name: 'ZhaoqingDownloadMgr',
                        path: 'downloadMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DownloadMgr'),
                    },
                    {
                        name: 'ZhaoqingUserBuilding',
                        path: 'userBuilding',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/UserBuilding'),
                    },
                    {
                        name: 'ZhaoqingUpgrading',
                        path: 'upgrading',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/Upgrading'),
                    },
                    {
                        name: 'ZhaoqingPlatformMgr',
                        path: 'platformMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformMgr'),
                    },
                    {
                        name: 'ZhaoqingBaseMaterials',
                        path: 'baseMaterials',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/base/BaseMaterials'),
                    },
                    {
                        name: 'ZhaoqingResStore',
                        path: 'resStore',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResStore'),
                    },
                    {
                        name: 'ZhaoqingResStoreDetail',
                        path: 'resStoreDetail',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResStoreDetail'),
                    },
                    {
                        name: 'ZhaoqingResInsServiceLog',
                        path: 'resInsServiceLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResInsServiceLog'),
                    },
                    {
                        name: 'ZhaoqingResDataProve',
                        path: 'resDataProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProve'),
                    },
                    {
                        name: 'ZhaoqingResDataProveNotice',
                        path: 'resDataProveNotice',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveNotice'),
                    },
                    {
                        name: 'ZhaoqingResDataProveSelection',
                        path: 'resDataProveSelection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveSelection'),
                    },
                    {
                        name: 'ZhaoqingResDataProveForm',
                        path: 'resDataProveForm',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResDataProveForm'),
                    },
                    {
                        name: 'ZhaoqingResRecordProve',
                        path: 'resRecordProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProve'),
                    },
                    {
                        name: 'ZhaoqingResRecordProveNotice',
                        path: 'resRecordProveNotice',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProveNotice'),
                    },
                    {
                        name: 'ZhaoqingResRecordProveSelection',
                        path: 'resRecordProveSelection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResRecordProveSelection'),
                    },
                    {
                        name: 'ZhaoqingPlatformCheck',
                        path: 'platformCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformCheck'),
                    },
                    {
                        name: 'ZhaoqingYiqiLogOffStateExamine',
                        path: 'yiqiLogOffStateExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/YiqiLogOffStateExamine'),
                    },
                    {
                        name: 'ZhaoqingLaboratoryBasicInfoExamine',
                        path: 'laboratoryBasicInfoExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LaboratoryBasicInfoExamine'),
                    },
                    {
                        name: 'ZhaoqingAnnualReportExamine',
                        path: 'annualReportExamine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/AnnualReportExamine'),
                    },
                    {
                        name: 'ZhaoqingMyApplyLog',
                        path: 'myApplyLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MyApplyLog'),
                    },
                    {
                        name: 'ZhaoqingCompetitionList',
                        path: 'competitionList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/competition/CompetitionList'),
                    },
                    {
                        name: 'ZhaoqingEstInstruList',
                        path: 'estInstruList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/estimate/EstInstruList'),
                    },
                    {
                        name: 'ZhaoqingUnitApplyLog',
                        path: 'unitApplyLog',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/UnitApplyLog'),
                    },
                    {
                        name: 'ZhaoqingApplyConfirm',
                        path: 'applyConfirm',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ApplyConfirm'),
                    },
                    {
                        name: 'ZhaoqingObjection',
                        path: 'objection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/Objection'),
                    },
                    {
                        name: 'ZhaoqingMyObjection',
                        path: 'myObjection',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/MyObjection'),
                    },
                    {
                        name: 'ZhaoqingYearReportCheck',
                        path: 'yearReportCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/YearReportCheck'),
                    },
                    {
                        name: 'ZhaoqingResCheck',
                        path: 'resCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResCheck'),
                    },
                    {
                        name: 'ZhaoqingDataCheck',
                        path: 'dataCheck',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataCheck'),
                    },
                    {
                        name: 'ZhaoqingPlatformManage',
                        path: 'platformManage',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformManage'),
                    },
                    {
                        name: 'ZhaoqingLaboratoryBasicInfo',
                        path: 'laboratoryBasicInfo',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LaboratoryBasicInfo'),
                    },
                    {
                        name: 'ZhaoqingPlatformChange',
                        path: 'platformChange',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformChange'),
                    },
                    {
                        name: 'ZhaoqingPlatformFillIn',
                        path: 'platformFillIn',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformFillIn'),
                    },
                    {
                        name: 'ZhaoqingInstrumentReservation',
                        path: 'instrumentReservation',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentReservation'),
                    },
                    {
                        name: 'ZhaoqingInstrumentUseStatistics',
                        path: 'instrumentUseStatistics',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentUseStatistics'),
                    },
                    {
                        name: 'ZhaoqingInstrumentReservationManage',
                        path: 'instrumentReservationManage',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentReservationManage'),
                    },
                    {
                        name: 'ZhaoqingInstrumentUseApplication',
                        path: 'instrumentUseApplication',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/InstrumentUseApplication'),
                    },
                    {
                        name: 'ZhaoqingPlatformPages',
                        path: 'platformPages',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformPages'),
                    },
                    {
                        name: 'ZhaoqingPlatformPageEdit',
                        path: 'platformPageEdit',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformPageEdit'),
                    },
                    {
                        name: 'ZhaoqingPlatformYearReport',
                        path: 'platformYearReport',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformYearReport'),
                    },
                    {
                        name: 'ZhaoqingPlatformDataProve',
                        path: 'platformDataProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/PlatformDataProve'),
                    },
                    {
                        name: 'ZhaoqingDataStore',
                        path: 'dataStore',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/DataStore'),
                    },
                    {
                        name: 'ZhaoqingDataCatagoryMgr',
                        path: 'dataCatagoryMgr',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataCatagoryMgr'),
                    },
                    {
                        name: 'ZhaoqingDataRes',
                        path: 'dataRes',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataRes'),
                    },
                    {
                        name: 'ZhaoqingOpenTopic',
                        path: 'openTopic',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/web/OpenTopic'),
                    },
                    {
                        name: 'ZhaoqingApiKeyApply',
                        path: 'apiKeyApply',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ApiKeyApply'),
                    },
                    {
                        name: 'ZhaoqingDataResProve',
                        path: 'dataResProve',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/DataResProve'),
                    },
                    {
                        name: 'ZhaoqingLibAwards',
                        path: 'libAwards',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibAwards'),
                    },
                    {
                        name: 'ZhaoqingLibExpert',
                        path: 'libExpert',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibExpert'),
                    },
                    {
                        name: 'ZhaoqingLibFile',
                        path: 'libFile',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibFile'),
                    },
                    {
                        name: 'ZhaoqingLibMedicine',
                        path: 'libMedicine',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibMedicine'),
                    },
                    {
                        name: 'ZhaoqingLibCommittee',
                        path: 'libCommittee',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibCommittee'),
                    },
                    {
                        name: 'ZhaoqingLibMeeting',
                        path: 'libMeeting',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibMeeting'),
                    },
                    {
                        name: 'ZhaoqingLibPaper',
                        path: 'libPaper',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPaper'),
                    },
                    {
                        name: 'ZhaoqingLibPatent',
                        path: 'libPatent',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPatent'),
                    },
                    {
                        name: 'ZhaoqingLibPerson',
                        path: 'libPerson',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPerson'),
                    },
                    {
                        name: 'ZhaoqingLibProject',
                        path: 'libProject',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibProject'),
                    },
                    {
                        name: 'ZhaoqingLibProjectProvince',
                        path: 'libProjectProvince',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibProjectProvince'),
                    },
                    {
                        name: 'ZhaoqingLibEnterprise',
                        path: 'libEnterprise',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibEnterprise'),
                    },
                    {
                        name: 'ZhaoqingLibPrincipalResults',
                        path: 'libPrincipalResults',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibPrincipalResults'),
                    },
                    {
                        name: 'ZhaoqingLibResearch',
                        path: 'libResearch',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibResearch'),
                    },
                    {
                        name: 'ZhaoqingLibSoftness',
                        path: 'libSoftness',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibSoftness'),
                    },
                    {
                        name: 'ZhaoqingLibStandard',
                        path: 'libStandard',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibStandard'),
                    },
                    {
                        name: 'ZhaoqingLibWorks',
                        path: 'libWorks',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/lab/LibWorks'),
                    },
                    {
                        name: 'ZhaoqingResReviewDuplication',
                        path: 'resReviewDuplication',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/resource/ResReviewDuplication'),
                    },
                    {
                        name: 'ZhaoqingScienceDataApplyList',
                        path: 'scienceDataApplyList',
                        component: () => import(/* webpackChunkName: 'User'*/ '../views/user/science/ScienceDataApplyList'),
                    }
                ]
            },
        ]
    }

]
//createWebHistory(process.env.BASE_URL)
const router = createRouter({
    mode: "history",
    history: createWebHistory(process.env.BASE_URL),
    base: '/',
    routes
})


router.afterEach((to, from) => {
    let bodySrcollTop = document.body.scrollTop
    if (bodySrcollTop !== 0) {
        document.body.scrollTop = 0
        return
    }
    let docSrcollTop = document.documentElement.scrollTop
    if (docSrcollTop !== 0) {
        document.documentElement.scrollTop = 0
    }
})

let previousRoute = null

router.beforeEach((to, from, next) => {
    previousRoute = from
    next()
})

export default router

export { previousRoute }